import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms'
@Component({
  selector: 'datos-autoriza',
  template: `
    <form name="form-inscripciones" [formGroup]="cursoAlumno">
      <div class="row">
        <label class="col-sm-2 col-form-label text-right pl-0"> 
          Autoriza:</label>
        <div class="col-sm-2 pr-0">
          <div
            class="input-group input-group-sm ">
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="autoriza"
              >
          </div>
        </div>
        <label class="col-sm-2 col-form-label text-right pl-0"> 
          Fecha autoriza:</label>
          <div 
              class="col-sm-2 p-0"
              [ngClass]="{'showError': !cursoAlumno.get('fechaAutorizacion').valid && cursoAlumno.get('fechaAutorizacion').touched}">
                <input 
                type="text" 
                class="form-control"
                formControlName="fechaAutorizacion"
                placeholder="yyyy-mm-dd"
                ngbDatepicker #a="ngbDatepicker"
                (click)="a.toggle()"
                >
            </div>
      </div>
    </form>
  `,
  styles: []
})
export class DatosAutorizaComponent implements OnInit {
  @Input() cursoAlumno: FormGroup
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-autoriza.component.ts